import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { initSentry, SentryProvider } from './config/sentry';

initSentry();
// import { UserbackProvider } from '@userback/react';

// Register service worker for FCM (runs in background, doesn't block app)
// This ensures service worker is ready when user logs in
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('[FCM] Service Worker registered on app load:', registration);
    })
    .catch((error) => {
      console.warn('[FCM] Service Worker registration failed on app load:', error);
      console.warn('[FCM] Will retry during login');
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <SentryProvider>
    <BrowserRouter>
      <HelmetProvider>
        {/* <UserbackProvider token={"42310|86591|wafzgHVVusZoqJkZ2bf9P7QKa"}> */}
        <App />
        {/* </UserbackProvider> */}
      </HelmetProvider>
    </BrowserRouter>
  </SentryProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
